// Dependencies
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import appConfig from '@nerdwallet/app-config';

// Local Dependencies
import * as builderActions from './actions';
import { flatOutline as flatOutlineReducer } from './reducer';
import { buildTree } from '../../lib/outline-manipulation';

export default (store) => (next) => (action) => {
  if (action.type in builderActions) {
    // If we're in an iframe, we need to alert parent of new page config.
    // Precompute forthcoming state changes before posting.
    if (process.env.IN_BROWSER && window && window.parent !== window) {
      const flatOutLineState = get(store.getState(), 'builder.flatOutline');
      const nextFlatOutlineState = flatOutlineReducer(flatOutLineState, action);
      const nextConfig = buildTree(nextFlatOutlineState);

      window.parent.postMessage(
        {
          landingPageData: true,
          pageConfig: JSON.stringify(nextConfig),
        },
        appConfig.SITE_BASE_URL
      );
    }
  }

  return next(action);
};
